// extracted by mini-css-extract-plugin
export var cardLayout = "_5u-1";
export var paginationContainer = "_5u-0";